export const FETCH_APP_SETTINGS_START = "FETCH_APP_SETTINGS_START";
export const FETCH_APP_SETTINGS_SUCCESS = "FETCH_APP_SETTINGS_SUCCESS";
export const CACHE_BACKUP_SETTINGS = "CACHE_BACKUP_SETTINGS";
export const CLEAN_CACHE = "CLEAN_CACHE";
export const SHOW_NOTIFICATION = "SHOW_NOTIFICATION";
export const HIDE_NOTIFICATION = "HIDE_NOTIFICATION";
export const FETCH_ALL_PLANS_START = "FETCH_ALL_PLANS_START";
export const FETCH_ALL_PLANS_SUCCESS = "FETCH_ALL_PLANS_SUCCESS";
export const INITIATE_NEW_SOCKET_CONNECTION = "INITIATE_NEW_SOCKET_CONNECTION";
